import { render } from "./PayCredit.vue?vue&type=template&id=31d36f82&scoped=true"
import script from "./PayCredit.vue?vue&type=script&lang=js"
export * from "./PayCredit.vue?vue&type=script&lang=js"

import "./PayCredit.vue?vue&type=style&index=0&id=31d36f82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d36f82"]])

export default __exports__